import Joi from '@hapi/joi'

export const exportCollectionPointSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
        "any.required": `Operation Entity required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Category").messages({
        "any.invalid": `Collection Category required`,
        "any.required": `Collection Category required`
    }),

    collectionPointCategoryID: Joi.number().invalid(0).required().label("CollectionPoint Category").messages({
        "any.invalid": `CollectionPoint Category required`,
        "any.required": `CollectionPoint Category required`
    }),

   

    collectionPointCode: Joi.string().required().min(2).max(2).label("Collection Point Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Collection Point Code required`,
        "string.pattern.base": `Collection Point Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
    collectionPointName: Joi.string().required().label("Collection Point Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Collection Point Name required`,
        "string.pattern.base": `Please enter valid Collection Point Name`,
    }),
    collectionPointLocation: Joi.string().label("Collection Point Location").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Collection Point Location required`,
        "string.pattern.base": `Please enter valid Collection Point Location`,
    }),
    isActive: Joi.boolean().label("Active")
}
export const exportCollectionPointFilteringSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select a Valid Group`,
        "any.required": `Group required`
    }),

    operationEntityID: Joi.number().invalid(0).required().label("operation Entity").messages({
        "any.invalid": `Please Select a Valid Operation Entity`,
        "any.required": `Operation Entity required`
    }),

    collectionCategoryID: Joi.number().invalid(0).required().label("collectionPoint Category").messages({
        "any.invalid": `Please Select a Valid Collection Category`,
        "any.required": `Collection Category required`
    }),




}














